  // sidebar b

  var trigger = $('.hamburger'),
  overlay = $('.overlay'),
  isClosed = false;

  trigger.click(function () {
    hamburger_cross();
  });

  function hamburger_cross() {

    if (isClosed == true) {
      overlay.hide();
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      event.preventDefault();
      $('body').css('overflow', 'auto');
    } else {
      overlay.show();
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      event.preventDefault();
      $('body').css('overflow', 'hidden');
    }
  }

  overlay.click(function () {
    overlay_cross();
  });

  function overlay_cross() {

    if (isClosed == true) {
      overlay.hide();
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      event.preventDefault();
      $('body').css('overflow', 'auto');
    } else {
      overlay.show();
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      event.preventDefault();
      $('body').css('overflow', 'hidden');

    }
    $('#warper').toggleClass('toggled');
  }

  $('[data-toggle="offcanvas"]').click(function () {
        $('#warper').toggleClass('toggled');
  });

// sidebar e
// document js begin
$(document).ready(function() {

  //去除移动端新闻详情页图片的宽高
  if($(window).width() < 1024){
    $('.news_content img').removeAttr('style').removeAttr('width').removeAttr('height');
  };

  $("#index_banner").owlCarousel({    
    singleItem:true,
    autoPlay: false,
    lazyLoad: true,
    slideSpeed : 300,
    paginationSpeed : 400,
    pagination: false,
    transitionStyle: "fade",
    navigation: true,
    navigationText: ["<i class='iconfont'>&#xe6c3;</i>", "<i class='iconfont'>&#xe851;</i>"]

  });

  // intro history
/*     $("#intro_history_list .list").each(function(i){
      $("#intro_history_list .list").slice(i*5,i*5+5).wrapAll('<div class="clearfix item"></div>');
    }); */
  
    $("#intro_history_list").owlCarousel({    
          singleItem:true,
          autoPlay: false,
          lazyLoad: true,
          slideSpeed : 300,
          paginationSpeed : 400,
          pagination: false,
          navigation: true,
          navigationText: ["<i class='iconfont'>&#xe6c3;</i>", "<i class='iconfont'>&#xe851;</i>"]
   
    });



  $(".product_d_slide").owlCarousel({    
        singleItem:true,
        autoPlay: false,
        lazyLoad: true,
        slideSpeed : 300,
        paginationSpeed : 400,
        pagination: false,
        navigation: true,
        transitionStyle: "fade",
        navigationText: ["<i class='iconfont'>&#xe6c3;</i>", "<i class='iconfont'>&#xe851;</i>"]
 
  });


});
// document js end

// swiper 切换开始
window.onload = function() {

}
// swiper 切换结束

// resize --------------------------------------------------------------------------------
$(window).resize(function() {

    $windowW = $(window).width();
    $windowH = $(window).height();

    $('.winH').css('height', $windowH);
    $headerH = $('header').height();
    $('.winInnerH').css('height', $windowH-$headerH);



/*     $partnerListH = $('.partner .inner').height();
    console.log($partnerListH);
    $('.partner .inner .title').css('height',$partnerListH); */


}).trigger('resize');

window.onload = function() {
  $(window).trigger('resize');






}
// resize --------------------------------------------------------------------------------
